import { useContext, useEffect, useState } from 'react'
import { Button, Divider, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import Title from '../custom/Title'
import { TransactionContext } from '../../contexts/TransactionContext'
import { TTransitionHistory } from '../../Models/Inbound'
import { CHARGE_TYPES, DOCUMENT_TYPES, PATHS, TRANSACTION_STATUS, TRANSACTION_TYPES } from '../../utils/constant'
import { TStepsProps } from '../../Models/common'
import { GridColDef } from '@mui/x-data-grid'
import Table from '../custom/Table'
import { TSummaryField } from '../../Models/Summary'
import StepNavigation from '../custom/StepNavigation'
import DownloadInvoice from './DownloadInvoice'
import useService from '../../hooks/useService'
import {fetchTransactionDocumentsList } from '../../services/Transactions'
import Modal from '../Modals'
import { formatDate, getFormattedCurrency, getTwoPointNumber, isEmpty } from '../../utils/helpers'
import DeliveryModal from './DeliveryModal'
import { Description } from '@mui/icons-material'
import { CustomerContext } from '../../contexts/CustomerContext'

type TSummaryProps = TStepsProps & {
    summaryDetails: TSummaryField[],
    transitionHistory: TTransitionHistory[]
}

const TRANSITION_DETAILS_FIELDS = [
    {
        id: "id",
        label: "Transition Type"
    },
    {
        id: "globalTransactionNumber",
        label: "Transaction Number"
    }, {
        id: "toStatus",
        label: "Transition Status"
    }
]

const List = styled.div`
    display: flex;
    gap:10px;
    flex-wrap:wrap;
    padding-bottom:10px;
`
const Item = styled.div`
    display: flex;
    padding: 10px;
    flex-direction: column;
    background: #f1f1f1;
    min-width: 250px;
    width: calc(25% - 10px);
    border-radius: 4px;
`

const ItemLabel = styled.span`
    font-size: 18px;
    font-weight: 600;
`

const ItemValue = styled.span`
    font-size: 16px;
`
type TMintedSalesSummaryKeys =
    'customerId'
    | 'customerName'
    | 'pvcName'
    | 'transactionDate'
    | 'purchasedGold'
    | 'purchasedSilver'
    | 'deliveryCharge'
    | 'totalTaxValue'
    | 'totalCharges'
    | 'roundingRs'
    | 'totalValue'

const SUMMARY_DETAILS: { id: TMintedSalesSummaryKeys, label: any, value: any }[] = [
    {
        id: 'customerId',
        label: "Customer Id",
        value: ""
    },
    {
        id: "customerName",
        label: "Customer Name",
        value: ""
    },
    {
        id: "pvcName",
        label: "PVC Name",
        value: ""
    },
    {
        id: "transactionDate",
        label: "Transaction Date",
        value: ""
    },
    {
        id: "purchasedGold",
        label: "Purchased Gold",
        value: ""
    },
    {
        id: "purchasedSilver",
        label: "Purchased Silver",
        value: ""
    },
    {
        id: 'deliveryCharge',
        label: 'Delivery Charges',
        value: ''
    },
    {
        id: 'totalTaxValue',
        label: "Total Tax Value Rs.",
        value: ''
    },
    {
        id: 'totalCharges',
        label: "Total Charges Rs.",
        value: ''
    },
    {
        id: 'roundingRs',
        label: "Rounding Rs.",
        value: ''
    },
    {
        id: 'totalValue',
        label: "Grand Total Rs.",
        value: ''
    },

]

const Summary = (props: TSummaryProps) => {

    const { prevSection, path, summaryDetails, transitionHistory } = props

    const navigate = useNavigate()
    const { id } = useParams()
    const { execute, store: { ecomTransactionStore } } = useService()
    const { pvcCenterDetails, transactionInfo, transactionDocuments ,ecomphysicalOrder} = ecomTransactionStore
    const [defaultSummaryDetails, setDefaultSummaryDetails] = useState<TSummaryField[]>([]);
    const [customSummaryDetails, setCustomSummaryDetails] = useState<TSummaryField[]>([]);
    const [defaultTransitionHistory, setDefaultTransitionHistory] = useState<TTransitionHistory[]>([]);
    const [showTransferMetalModal, setShowTransferMetalModal] = useState(false);
    const [showDeliveryModal, setShowDeliveryModal] = useState(false);
    const { customerConfig } = useContext(CustomerContext)
    const { globalTransactionNumber, status, updatedAt } = transactionInfo

    useEffect(() => {
        if (summaryDetails?.length) {
            setDefaultSummaryDetails(customSummaryDetails)
        }
        else if(customSummaryDetails?.length){
            setDefaultSummaryDetails(customSummaryDetails)
        }
        if (transitionHistory?.length) {
            setDefaultTransitionHistory(transitionHistory)
        }

    }, [summaryDetails, transitionHistory,customSummaryDetails])

    const getTransitionDocumentsList = () => {
         execute(()=> fetchTransactionDocumentsList({
            globalTransactionNumber: transactionInfo.globalTransactionNumber!,
            transactionType: transactionInfo.transactionType
        }))
    }

    useEffect(() => {
        setCustomSummaryDetails(getSummary())
    }, [ecomphysicalOrder])
    
    
  const getSummary = () => {
        let totalTaxValue = 0
        Array.isArray(ecomphysicalOrder.taxes) ? ecomphysicalOrder.taxes.forEach((tax) => {
    totalTaxValue += tax.taxAmount
}) : Object.values(ecomphysicalOrder.taxes || {}).forEach((tax: any) => {
    totalTaxValue += tax.taxAmount
})
        let totalCharges = 0
        ecomphysicalOrder.charges?.forEach((charge) => {
            totalCharges += charge.preTaxAmount
            totalTaxValue += charge.postTaxAmount - charge.preTaxAmount
        })
        const roundingRs = getTwoPointNumber((Math.round(ecomphysicalOrder.totalPrice || 0) - (ecomphysicalOrder.totalPrice || 0)) ?? 0)
        return SUMMARY_DETAILS.map(field => {
            switch (field.id) {
                case 'customerId':
                    field.value = customerConfig.customerRefNo
                    break;
                case 'customerName':
                    field.value = customerConfig.fullName
                    break;
                case 'pvcName':
                    field.value = pvcCenterDetails.name
                    break;
                case 'purchasedGold':
                    field.value = ecomphysicalOrder.totalGoldWeight ? ecomphysicalOrder.totalGoldWeight : 0 + ' gm'
                    break;
                case 'purchasedSilver':
                    field.value = ecomphysicalOrder.totalSilverWeight ? ecomphysicalOrder.totalSilverWeight : 0 + ' gm'
                    break;
                case 'transactionDate':
                    field.value = updatedAt ? formatDate(updatedAt) : ''
                    break;
                case 'deliveryCharge':
                    const deliveryCharge = ecomphysicalOrder.charges?.filter((charge) => {
                        return charge.chargeId === CHARGE_TYPES.DELIVERY_CHARGE
                    })[0]
                    field.value = deliveryCharge ? getFormattedCurrency(deliveryCharge.postTaxAmount) : null
                    break;
                case 'totalTaxValue':
                    field.value = getFormattedCurrency((totalTaxValue)) || 0
                    break;
                case 'totalCharges':
                    field.value = getFormattedCurrency((totalCharges))
                    break;
                case 'roundingRs':
                    field.value = getFormattedCurrency((roundingRs))
                    break;
                case 'totalValue':
                    field.value = getFormattedCurrency((ecomphysicalOrder.totalPrice || 0))
                    break;
            }
            return field
        })
    }

    




    const getTransitionDetailsColumns = (): GridColDef<any>[] => {
        let minWidth = 380
        return TRANSITION_DETAILS_FIELDS.map(transitionDetail => {
            return {
                field: transitionDetail.id,
                headerName: transitionDetail.label,
                minWidth
            }
        })
    }





    return (
        <div>
            <div style={{ padding: '20px 10px 10px 0', display: 'flex', justifyContent: 'space-between' }}>
                <Title >Transaction Summary</Title>
            </div>
            <Divider />
            {transitionHistory.length > 0 &&
                <div style={{ padding: '20px 0px' }}>
                    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 0', color: '#7f7d76' }}>Transition Details</Title>
                    <Table columns={getTransitionDetailsColumns()} rows={defaultTransitionHistory} />
                </div>
            }

            <List>
                {
                    defaultSummaryDetails.map((field) => {
                        if (field.value !== undefined && field.value !== null) {
                            return <Item>
                                <ItemLabel><span>{field.label}</span></ItemLabel>
                                <ItemValue><span>{field.value}</span></ItemValue>
                            </Item>
                        }
                    })
                }
            </List>
            <DeliveryModal
                open={showDeliveryModal}
                onClose={() => setShowDeliveryModal(false)}
            />
        </div>
    )
}

export default Summary